/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export function resetPresetToDefaults(
  defaults,
  setters,
  refUpdaters,
  config,
  updateSprayParamsFunc,
  onClearChangesFlag
) {
  if (!defaults) return;
  setters.setScaleVal(defaults.scale);
  setters.setRadiusVal(defaults.radius);
  setters.setDensityVal(defaults.density);
  setters.setSpeedFactorVal(defaults.speedFactor);
  setters.setActualSpeed(defaults.scale);
  setters.setActualRadius(defaults.radius);
  setters.setActualDensity(defaults.density);
  setters.setActualSpeedFactor(defaults.speedFactor);
  if (refUpdaters.scaleValRef?.current) {
    refUpdaters.scaleValRef.current.textContent = defaults.scale.toFixed(2);
  }
  if (refUpdaters.radiusValRef?.current) {
    refUpdaters.radiusValRef.current.textContent = defaults.radius;
  }
  if (refUpdaters.densityValRef?.current) {
    refUpdaters.densityValRef.current.textContent = defaults.density;
  }
  if (refUpdaters.speedFactorValRef?.current) {
    refUpdaters.speedFactorValRef.current.textContent = defaults.speedFactor.toFixed(1);
  }
  setters.setUserOverrides(prev => {
    const updated = { ...prev };
    delete updated[config.activePreset];
    return updated;
  });
  if (onClearChangesFlag) {
    onClearChangesFlag();
  }
  if (typeof updateSprayParamsFunc === 'function') {
    updateSprayParamsFunc(
      defaults.radius,
      defaults.density,
      defaults.scale,
      defaults.speedFactor,
      config.activePreset,
      config.presets[config.activePreset]?.enableDrips || false,
      config.presets[config.activePreset]?.paintConsumption || 1,
      config.presets[config.activePreset],
      config.activeCanId,
      config.currentColor,
      config.cans
    );
  }
}
export function createResetConfig(
  defaults,
  settersObj,
  refsObj,
  configObj,
  updateFunc,
  clearFlagFunc
) {
  return {
    defaults,
    setters: settersObj,
    refUpdaters: refsObj,
    config: configObj,
    updateSprayParamsFunc: updateFunc,
    onClearChangesFlag: clearFlagFunc
  };
}
